import React from 'react';
import useWidgetId from '../../hooks/widget/useWidgetId';
import useWidgetDetail from '../../hooks/widget/useWidgetDetail';
import useCreateWidget from '../../hooks/widget/useCreateWidget';
import WidgetForm from '../../views/widget/detail/WidgetForm';
import FullPageSpinner from '../../components/spinner/FullPageSpinner';
import useRedirect from '../../hooks/common/useRedirect';
import { WIDGET_ALL_LIST_URL_PATH } from '../../constants/service/common/urlConstants';
import PageTemplate from '../../components/template/PageTemplate';
import { WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import usePrompt from '../../hooks/common/usePrompt';

const WidgetCopy = () => {
  const widgetId = useWidgetId();
  const redirect = useRedirect();
  const {
    data,
    isSuccess: isDetailSuccess,
    isLoading: isDetailLoading,
    isError: isDetailError,
  } = useWidgetDetail(widgetId);
  const { createWidget, isSuccess, isLoading } = useCreateWidget();

  usePrompt(!(isSuccess || isLoading), '편집을 중단하시겠습니까?');

  if (isDetailLoading) return <FullPageSpinner />;

  if (isDetailError) redirect(WIDGET_ALL_LIST_URL_PATH);

  if (isDetailSuccess)
    return (
      <PageTemplate pageName={WIDGET_PAGE_NAME.WIDGET_COPY}>
        <WidgetForm onFinish={createWidget} initialValue={data} isEdit={true} />
      </PageTemplate>
    );
};

export default WidgetCopy;
